// eslint-disable-next-line import/prefer-default-export
import { STUBS } from '../../socketStubs/stubNames';

const {
  PC: {
    EXCERCISE_DATA_TRANSPORT_FROM_WL,
    CHECKIN_DATA_TRANSPORT_FROM_WL,
    CLASSROOM_DATA_TRANSPORT_FROM_WL,
    QUESTIONNAIRE_DATA_TRANSPORT_FROM_WL,
    CALLROLL_DATA_TRANSPORT_FROM_WL,
    POST_DATA_TRANSPORT_FROM_WL,
    ANNOUNCEMENT_DATA_TRANSPORT_FROM_WL,
    LESSON_PLAN_DATA_TRANSPORT_FROM_WL,
    VIDEOTEACH_DATA_TRANSPORT_FROM_WL,
  },
} = STUBS;

export const MIRRORING_PAGENAME = {
  LOGIN: 'login',
  HOME: 'home',
  EXERCISE: 'excercise',
  CHECKIN: 'checkin',
  // CHECKIN_NEW: 'checkin',
  TERMINATE: 'terminate',
  CLASSROOM: 'classroom',
  EXERCISE_STATISTICS: 'excercise_statistics',
  EXERCISE_QUESTION: 'excercise_question',
  FINISH: 'finish',
  QUESTIONNAIRE: 'questionnaire',
  CALLROLL: 'callroll',
  POST: 'post',
  ANNOUNCEMENT: 'announcement',
  LESSON_PLAN: 'lessonPlan',
  VIDEOTEACH: 'videoteach',
  // AI_LESSON_PLAN: 'ai_lessonPlan', // AI课堂
};

export const CHECKIN_STATUS = {
  CHECKED: 1, // 已签到
  LATE: 2, // 迟到
  UNCHECKED: 3, // 未签到
  TRUANT: 4, // 旷课
  LEAVE: 5, // 请事假
  SICKLEAVE: 6, // 请病假
};
export const TERM_RESOURCE_TYPE = {
  VIDEO: 1, // 视频库
  DOCUMENT: 3, // 课件库
};
export const TERM_RESOURCE_TYPE_NAME = {
  [TERM_RESOURCE_TYPE.VIDEO]: '视频库',
  [TERM_RESOURCE_TYPE.DOCUMENT]: '课件库',
};
// 资源/活动类型
export const RESOURSE_TYPE = {
  SIGN: 0, // 签到
  SIGN_NEW: 6, // 新签到
  EXERCISE: 1, // 练习
  NEW_EXAM: 11, // 新版练习
  QUESTIONIARE: 2, // 问卷
  ANNOUNCEMENT: 3, // 公告
  ROLLCALL: 4, // 点名
  DISCUSSION: 5, // 讨论
  HOMEWORK: 7, // 章节测验 作业
  UNIT: 8, // 视频 pdf 富文本 讨论 直播
  EXAM: 9, // 考试
  DOCTEACH: 10, // 教案(ppt doc excel等)
  NEWTEACH: 14, // ai课堂课件资源库(ppt doc excel等)
  LESSON_UNIT: 15, // ai课堂课件资源库章节信息
  VIDEOTEACH: 17, // ai课堂视频资源库 学期资源库视频库资源
  INTERACTIVE_COURSEWARE: 23, // AI 课堂互动课件活动
};

// 这个定义是新版 AI慕课堂的活动类型，和上面的RESOURSE_TYPE部分对应，部分又不同（主要是后端类型和上面的对应的不上了）

// 新版 AI课堂对应的活动类型，和 react-teach后台工程里面的定义对应
export const NEW_ACTIVITY_TYPE = {
  // 问卷
  QUESTIONIARE: {
    key: 1,
    name: '问卷',
    class: 'questioniare',
  },
  // 练习
  EXERCISE: {
    key: 2,
    name: '练习',
    class: 'exercise',
  },
  // 公告
  ANNOUNCEMENT: {
    key: 3,
    name: '公告',
    class: 'announcement',
  },
  // 讨论
  DISCUSSION: {
    key: 4,
    name: '讨论',
    class: 'discussion',
  },
  // 点名
  ROLLCALL: {
    key: 5,
    name: '点名',
    class: 'rollcall',
  },
  // 签到
  SIGN: {
    key: 6,
    name: '签到',
    class: 'sign',
  },
  // 新版练习
  MOC_PAPER: {
    key: 11,
    name: '练习',
    class: 'exercise',
  },
  // 学期资源库(pdf,ppt)
  TEACH: {
    key: 14,
    name: '课件',
    class: 'teachDoc',
  },
  VIDEOTEACH: {
    key: 17,
    name: '视频',
    class: 'videoteach',
  },
  // 互动课件的活动类型，资源内容类型为 15，两者不可混用。
  INTERACTIVE_COURSEWARE: {
    key: 23,
    name: '互动课件',
    class: 'interactiveCourseware',
  },
};

export const SUPPORT_UNPUBLISH_LIST = ['QUESTIONIARE', 'EXERCISE'];
// i课堂课件资源库章节里面具体信息
export const LESSON_UNIT_RESOURSE_TYPE = {
  VIDEO: 1,
  DOC: 3,
  RICH: 4,
  QUIZE: 5,
  DISCUSSION: 6,
};
export const LESSON_UNIT_RESOURSE_NAME = {
  [LESSON_UNIT_RESOURSE_TYPE.VIDEO]: {
    name: '视频',
  },
  [LESSON_UNIT_RESOURSE_TYPE.DOC]: {
    name: '文档',
  },
  [LESSON_UNIT_RESOURSE_TYPE.RICH]: {
    name: '富文本',
  },
  [LESSON_UNIT_RESOURSE_TYPE.QUIZE]: {
    name: '测验',
  },
  [LESSON_UNIT_RESOURSE_TYPE.DISCUSSION]: {
    name: '讨论',
  },
};

export const PAGENAME_MAP = {
  [MIRRORING_PAGENAME.LOGIN]: {
    text: '登录',
    // TODO: 这个stubName有吗
    stubName: '',
  },
  [MIRRORING_PAGENAME.HOME]: {
    text: 'home',
    // TODO: 这个stubName有吗
    stubName: '',
  },
  [MIRRORING_PAGENAME.EXERCISE]: {
    text: '练习',
    stubName: EXCERCISE_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.EXERCISE,
  },
  [MIRRORING_PAGENAME.CHECKIN]: {
    text: '签到',
    stubName: CHECKIN_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.SIGN,
    resourceTypes: [RESOURSE_TYPE.SIGN, RESOURSE_TYPE.SIGN_NEW],
  },
  // [MIRRORING_PAGENAME.CHECKIN_NEW]: {
  //   text: '课堂签到',
  //   stubName: CHECKIN_DATA_TRANSPORT_FROM_WL,
  //   resourceType: RESOURSE_TYPE.SIGN_NEW,
  // },
  [MIRRORING_PAGENAME.CLASSROOM]: {
    text: '课堂',
    stubName: CLASSROOM_DATA_TRANSPORT_FROM_WL,
  },
  [MIRRORING_PAGENAME.QUESTIONNAIRE]: {
    text: '问卷',
    stubName: QUESTIONNAIRE_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.QUESTIONIARE,
  },
  [MIRRORING_PAGENAME.CALLROLL]: {
    text: '点名',
    stubName: CALLROLL_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.ROLLCALL,
  },
  [MIRRORING_PAGENAME.POST]: {
    text: '讨论',
    stubName: POST_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.DISCUSSION,
  },
  [MIRRORING_PAGENAME.ANNOUNCEMENT]: {
    text: '公告',
    stubName: ANNOUNCEMENT_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.ANNOUNCEMENT,
  },
  [MIRRORING_PAGENAME.LESSON_PLAN]: {
    // text: '教案',
    text: '课件',
    stubName: LESSON_PLAN_DATA_TRANSPORT_FROM_WL,
    resourceType: RESOURSE_TYPE.DOCTEACH,
    resourceTypes: [RESOURSE_TYPE.DOCTEACH, RESOURSE_TYPE.NEWTEACH],
  },
  // [MIRRORING_PAGENAME.AI_LESSON_PLAN]: {
  //   // text: '教案',
  //   text: '课件',
  //   stubName: LESSON_PLAN_DATA_TRANSPORT_FROM_WL,
  //   resourceType: RESOURSE_TYPE.NEWTEACH,
  // },
  [MIRRORING_PAGENAME.FINISH]: {
    text: '已结束',
    stubName: 'DISCONNECTED_NOTIFICATION_FROM_WL',
  },
};
export const PAGENAME_MAP_AICLASSROOM = {
  [MIRRORING_PAGENAME.LOGIN]: {
    text: '登录',
    // TODO: 这个stubName有吗
    stubName: '',
  },
  [MIRRORING_PAGENAME.HOME]: {
    text: 'home',
    // TODO: 这个stubName有吗
    stubName: '',
  },
  [MIRRORING_PAGENAME.EXERCISE]: {
    text: '练习',
    stubName: EXCERCISE_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.EXERCISE.key,
    resourceTypes: [
      NEW_ACTIVITY_TYPE.EXERCISE.key,
      NEW_ACTIVITY_TYPE.MOC_PAPER.key,
    ],
  },
  [MIRRORING_PAGENAME.CHECKIN]: {
    text: '签到',
    stubName: CHECKIN_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.SIGN.key,
  },
  // [MIRRORING_PAGENAME.CHECKIN_NEW]: {
  //   text: '课堂签到',
  //   stubName: CHECKIN_DATA_TRANSPORT_FROM_WL,
  //   resourceType: RESOURSE_TYPE.SIGN_NEW,
  // },
  [MIRRORING_PAGENAME.CLASSROOM]: {
    text: '课堂',
    stubName: CLASSROOM_DATA_TRANSPORT_FROM_WL,
  },
  [MIRRORING_PAGENAME.QUESTIONNAIRE]: {
    text: '问卷',
    stubName: QUESTIONNAIRE_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.QUESTIONIARE.key,
  },
  [MIRRORING_PAGENAME.CALLROLL]: {
    text: '点名',
    stubName: CALLROLL_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.ROLLCALL.key,
  },
  [MIRRORING_PAGENAME.POST]: {
    text: '讨论',
    stubName: POST_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.DISCUSSION.key,
  },
  [MIRRORING_PAGENAME.ANNOUNCEMENT]: {
    text: '公告',
    stubName: ANNOUNCEMENT_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.ANNOUNCEMENT.key,
  },
  [MIRRORING_PAGENAME.LESSON_PLAN]: {
    // text: '教案',
    text: '课件',
    stubName: LESSON_PLAN_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.TEACH.key,
    // 互动课件复用课件投屏页面，在页面内按 contentType=15 渲染 HTML。
    resourceTypes: [
      NEW_ACTIVITY_TYPE.TEACH.key,
      NEW_ACTIVITY_TYPE.INTERACTIVE_COURSEWARE.key,
    ],
  },
  // [MIRRORING_PAGENAME.AI_LESSON_PLAN]: {
  //   // text: '教案',
  //   text: '课件',
  //   stubName: LESSON_PLAN_DATA_TRANSPORT_FROM_WL,
  //   resourceType: RESOURSE_TYPE.NEWTEACH,
  // },
  [MIRRORING_PAGENAME.FINISH]: {
    text: '已结束',
    stubName: 'DISCONNECTED_NOTIFICATION_FROM_WL',
  },
  [MIRRORING_PAGENAME.VIDEOTEACH]: {
    text: '视频',
    stubName: VIDEOTEACH_DATA_TRANSPORT_FROM_WL,
    resourceType: NEW_ACTIVITY_TYPE.VIDEOTEACH.key,
  },
};

export const RESOURSE_TYPE_CLASS = {
  0: {
    class: 'sign',
    name: '签到',
  },
  1: {
    class: 'exercise',
    name: '练习',
  },
  // 新版练习共用老版class
  11: {
    class: 'exercise',
    name: '练习',
  },
  2: {
    class: 'questioniare',
    name: '问卷',
  },
  3: {
    class: 'announcement',
    name: '公告',
  },
  4: {
    class: 'rollcall',
    name: '点名',
  },
  5: {
    class: 'discussion',
    name: '讨论',
  },
  6: {
    class: 'sign',
    name: '签到', // ai课堂签到
  },
  10: {
    class: 'teachDoc',
    // name: '教案',
    name: '课件',
  },
  14: {
    class: 'newTeachDoc',
    // name: '教案',
    name: '课件',
  },
  23: {
    class: 'interactiveCourseware',
    name: '互动课件',
  },
};

// 教案类型
export const DOC_TYPE = {
  PPT: 0, // ppt
  DOC: 1,
  XLS: 2,
  PDF: 3,
};
export const DOC_TYPE_CLASS = {
  0: 'ppt',
  1: 'doc',
  2: 'xls',
  3: 'pdf',
  13: 'ppt',
};

export const LESSON_TYPE = {
  PPT: 0,
  PPTX: 0,
  PDF: 3,
  PPT_NEW: 13,
};

export const LESSON_STATUS = {
  PLAY: 'play',
  PREVIEW: 'preview',
};
